import { colors, Icon, Typography, usePopoverState } from '@ui-components/neo.tax';
import { ReactComponent as InfoCircleIcon } from '@ui-components/neo.tax/dist/icons/info-circle.svg';
import React, { ReactElement } from 'react';

import { BareDisclosure, ReasoningPopover } from './ticket-grouping-list.styled';

const stopPropagation = (e: React.MouseEvent): void => {
  e.stopPropagation();
};

// Click-popover holding the match reasoning, opened by an info icon on the row. Shared by the
// grouping-parent header (TicketGroupingItem) and the per-ticket rows (TicketRow) so both
// matching-artifact surfaces present identically. "New"-ness is conveyed by the surrounding
// "New matches" section, so the trigger is uniform across all matches.
export const ReasoningTrigger = ({ reasoning }: { reasoning: string }): ReactElement => {
  const popover = usePopoverState({ gutter: 6, placement: 'bottom-end' });
  const show = (): void => popover.show();
  const hide = (): void => popover.hide();
  return (
    // Stop propagation so opening the reasoning doesn't toggle the surrounding row's click
    // behavior (e.g. a grouping's expansion). Reveal on hover as well as click; hovering into
    // the popover keeps it open.
    <span onClick={stopPropagation} onMouseEnter={show} onMouseLeave={hide}>
      <BareDisclosure state={popover} aria-label="Show match reasoning">
        {/* size 3 (12px) matches the xs meta-row text height. */}
        <Icon node={<InfoCircleIcon />} size={3} />
      </BareDisclosure>
      <ReasoningPopover state={popover} label="Match reasoning" onMouseEnter={show} onMouseLeave={hide}>
        <Typography fontSize="sm" color={colors.gray[700]}>
          {reasoning}
        </Typography>
      </ReasoningPopover>
    </span>
  );
};
